import styled, { css } from 'styled-components';

export const FloatImage = styled.a`
    position:fixed;
    top: 150px;
    left: 20px;
    z-index: 100;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    background-color: transparent

    @media (min-width: 1080px) {
        top: 100px;
        left: 50px;
        width: 350px;
        height: 350px;
    }
`;